import { Pipe, PipeTransform } from "@angular/core";
import { wallOf } from "../shared/time-zone-offset";
import { originalOf } from "./flights2.time-zone";
import { Flight } from "./models/flight.model";
// The pipes of the flights page and the functions behind them, which the export to Excel shares.

/** The value at a dotted path of the row, as the grid's `field` names it: `engineData.engine1ActualN1`. */
export function fieldValueOf(row: object, path: string): unknown {
    return path.split(".").reduce<unknown>((value, key) => (value === null || value === undefined ? value : value[key]), row);
}

/** A date the pilot logged, `YYYY-MM-DD`, as `dd-MM-yyyy`. Never through `Date`, which would move it to another day across time zones. */
export function logDateOf(day: unknown): string {
    if (typeof day !== "string" || !day) return "";
    const [year, month, date] = day.slice(0, 10).split("-");
    return `${date}-${month}-${year}`;
}

/** A TIME column, `HH:mm:ss`, as the logbook writes it: `HH:mm`. */
export function logTimeOf(time: unknown): string {
    return typeof time === "string" ? time.slice(0, 5) : "";
}

@Pipe({ name: "fieldValue" })
export class FieldValuePipe implements PipeTransform {
    transform(row: object, path: string): unknown {
        return fieldValueOf(row, path);
    }
}

@Pipe({ name: "logDate" })
export class LogDatePipe implements PipeTransform {
    transform(day: unknown): string {
        return logDateOf(day);
    }
}

/** A decimal with a dot and no thousands separator, whatever the language: `3100.40`. */
@Pipe({ name: "fixed" })
export class FixedPipe implements PipeTransform {
    transform(value: unknown, decimals = 2): string {
        return value === null || value === undefined || value === "" ? "" : Number(value).toFixed(decimals);
    }
}

@Pipe({ name: "logTime" })
export class LogTimePipe implements PipeTransform {
    transform(time: unknown): string {
        return logTimeOf(time);
    }
}

/** A moment kept in UTC as `dd-MM-yyyy HH:mm` by the clocks of a time zone. */
export function zonedDateTimeOf(value: unknown, timeZone: string): string {
    if (!(value instanceof Date)) return "";
    const { day, time } = wallOf(value.getTime(), timeZone);
    return `${day.slice(8, 10)}-${day.slice(5, 7)}-${day.slice(0, 4)} ${time.slice(0, 5)}`;
}

@Pipe({ name: "zonedDateTime" })
export class ZonedDateTimePipe implements PipeTransform {
    transform(value: unknown, timeZone: string): string {
        return zonedDateTimeOf(value, timeZone);
    }
}

/** The flight as the organization keeps it, for a row that shows it in another time zone. */
@Pipe({ name: "original" })
export class OriginalFlightPipe implements PipeTransform {
    transform(flight: Flight): Flight {
        return originalOf(flight);
    }
}
